import { URLData } from '@susu/headless-commerce/utils/tracking/segment'

export const configuratorURLData = (
  step: string,
): {
  url: string
  locationId: string
  path: string
} => {
  const { url, locationId } = URLData()

  const locationIdObject = new URL(locationId)
  const URLObject = new URL(url)

  locationIdObject.pathname += `/${step}`
  URLObject.pathname += `/${step}`

  return {
    url: URLObject.toString(),
    locationId: locationIdObject.toString(),
    path: URLObject.pathname,
  }
}
